import TechProductsPage from './TechProductsPage';
import { IframeTechProductPageRoutes } from './constants'

export default TechProductsPage;
export {IframeTechProductPageRoutes};
